<template>
  <div class="info">
    <!-- 导航栏 -->
    <nav-header :href="this.href"></nav-header>

    <!-- 定宽 -->
    <div class="container">
      <div class="info-1">
        <ul>
          <li  @click="goInfo">关于我们</li>
          <li  class="active">联系我们</li>
        </ul>
      </div>
      <!-- 右侧 内容 -->
      <div class="info-2">
        <h3>联系我们</h3>
        <!-- 下环线 -->
        <div class="bink"></div>

  
        <div class="i2-con">
          <p>
            联系电话：010-51667195
          </p>
          <p>联系地址：北京市密云区经济开发区西统路8号西田各庄镇政府办公楼508室—369</p>
          <!-- <img src="/imgs/dt.jpg" alt=""> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NavHeader from "./../components/NavHeader";
export default {
  name: "info",
  components: {
    NavHeader,
  },
  data() {
    return {
      href: "/",
    };
  },
  mounted() {
    document.title = "晋江奇境 ";
  },
  methods: {
    // 跳转关于我们
    goInfo() {
      this.$router.push("/info");
    },
    // 跳转联系我们
    goXy2() {
      this.$router.push("/xy2");
    },
   
  },
};
</script>
<style lang="scss" scoped>
@import "./../assets/scss/base.scss";
@import "./../assets/scss/config.scss";
@import "./../assets/scss/mixin.scss";
.info {
  width: 100%;
  background-color: #f0f0f0;
  // banner
  .i2-banner {
    width: 100%;
    height: 250px;
    background-color: pink;
    margin-bottom: 120px;
    img {
      width: 100%;
      height: 100%;
    }
  }

  // 定宽布局
  .container {
    // @include flex();
    display: flex;
    justify-content: space-between;
    // height: 800px;
    margin-bottom: 30px;
    // 左侧
    .info-1 {
      width: 30%;
      height: 100%;
      margin-right: 20px;
      // background-color: red;
      ul {
        width: 190px;
        background-color: #fff;
        border-bottom: 2px solid #dfe1e2;
        border-radius: 3px;
        padding: 13px 15px;
        margin: 0 auto;
        li {
          width: 90%;
          height: 40px;
          line-height: 40px;
          font-size: 14px;
          font-weight: bold;

          box-sizing: border-box;
          margin: 10px auto;
          cursor: pointer;
          padding-left: 20px;
          &.active {
            background-color: #3890e1;
            color: #fff;
          }
        }
      }
    }
    // 右侧
    .info-2 {
      width: 70%;
      height: 100%;
      background: #fff;
      padding: 40px;
      box-sizing: border-box;
      text-align: center;
      h3 {
        font-size: 24px;
      }
      // 下划线
      .bink {
        width: 30px;
        height: 3px;
        background-color: #000;
        margin: 10px auto;
      }

      // banner
      .i2-banner {
        width: 100%;
        height: 300px;
        background: url("/imgs/b1.jpg") no-repeat center;
        background-size: cover;
        margin: 30px auto;
      }

      // 文章
      .i2-con {
        text-align: left;
        p {
          font-size: 13px;
          line-height: 3.2em;
          color: #4e4b4b;
          margin: 15px auto;
          padding: 10px;
          box-sizing: border-box;
          text-align: left;
        }
        h3 {
          font-size: 18px;
          margin: 15px auto;
        }
        img {
          // height: 300px;
          width: 100%;
        }
      }
    }
  }
}
</style>
